import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 

import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
//import { DropzoneArea } from 'material-ui-dropzone';
//import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { FileUploader } from "react-drag-drop-files";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';  

export default class Productimport extends Component {
	
	constructor(props) 
	  {super();
		 this.state = {ExportData:[],redirect:false,pagename:'',errormessage:'',open:false,imgfile:'',primarybtntext:'Import'}
	  }

 componentDidMount()
	{
		document.title = "Isifol - Products Import";
		if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Login'
          })
		  }
this.apicallforexport();			  
	}
	apicallforexport(){
	

	 axios.post(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=productexport')
     
	
  .then(resp => {  		
    if(resp.data.length>0){

			this.setState({ 		   
			  ExportData:resp.data,  			   
			   });
		
			     }
	 else{
		   this.setState({ExportData:[],});
	 }
 
    });
}
	handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
  OnImportSubmit=(event)=>{
	   event.preventDefault(); 
	   var selectedFile = this.state.imgfile;
	   if (!selectedFile || selectedFile === "") {
    this.setState({
      errormessage: "Please upload a CSV file.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }

var validTypes = ["text/csv", "application/vnd.ms-excel"];
  if (validTypes.indexOf(selectedFile.type) === -1) {
    this.setState({
      errormessage: "Invalid file type. Only CSV files are allowed.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }
	  if( this.state.imgfile[0]==="")
	  {
   this.setState({ errormessage:"Upload file.", open: true });
    window.scrollTo({ top: 0 });
    return false;
	  }		  
	   var formData = new FormData();
	 formData.append('action','prodimport')
		   formData.append('Filedata',selectedFile)		   
	formData.append('userid',localStorage.getItem("ISIuserid"))
	this.setState({primarybtntext:'Processing...'});
	axios.post(localStorage.getItem("ISIurl")+"ajaxproducts.php", formData, {
	}).then(res => {
		
		this.setState({primarybtntext:'Import',open:true,errormessage:'Uploaded successfully'});
		
	});
  }
 handleFilesChange = (file) => {
  this.setState({ imgfile: file });
};
	render() {
if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		const maxProducts = Math.max(
  ...this.state.ExportData.map(product => (product.productprice ? product.productprice.length : 0))
);
	const fileTypes = ["CSV"];
	 return (
  
	 <React.Fragment> 
	  <div className="pagebox-col">
	 <div className="">
			<div className="boxheading">
				  <div className="contntpad">
					 <p>  <Collapse in={this.state.open}>
										<Alert
										  action={
											<IconButton
											  aria-label="close"
											  color="inherit"
											  size="small"
											  onClick={() => {
											   this.handleErrorclose();
											  }}
											>
											  <CloseIcon fontSize="inherit" />
											</IconButton>
										  } severity="error"
										>
										{this.state.errormessage}
										</Alert>
								</Collapse></p>
				  <h2> Import Product</h2>
				  </div> </div>
	   <div className="contntpad ">
	    <div className="formviewatt ">
	   
	


	 <p className="fileuploaddrop">
	 <FileUploader
  multiple={false}
  handleChange={this.handleFilesChange}
  name="file"
  types={fileTypes}
>
  <div style={{ padding: '20px', border: '2px dashed #ccc', borderRadius: '6px', textAlign: 'center' }}>
    <p>Drag & drop your CSV file here, or click to browse.</p>
  </div>
</FileUploader>
</p>
<p>
  {this.state.imgfile
    ? "File name: " + this.state.imgfile.name
    : "No files uploaded yet."}
</p>
	 
 <p className="alignright"><Button variant="standard" className="frmSecondarybtn" onClick={this.OnImportSubmit}>
								  {this.state.primarybtntext}
						</Button>&nbsp; <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="exportbtn"
                    table="products"
                    filename="Products"
                    sheet="Products"
                    buttonText="EXPORT"
					variant="contained"/></p>
	   <div className="clear"></div>
	   </div>  </div>
	   </div>
	   </div>
	   <Table id="products" style={{ display: 'none' }}>
  <TableHead>
    <TableRow>
      <TableCell>Item Code</TableCell>
      <TableCell>Description</TableCell>
	   <TableCell>Category</TableCell>
	    <TableCell>Sales Ledger Account</TableCell>
      <TableCell>Sales Tax Rate</TableCell>
	  <TableCell>Expense Description</TableCell>
	  <TableCell>Cost Price</TableCell>
	  <TableCell>Expense Ledger Account</TableCell>
	  <TableCell>Notes</TableCell>
	  <TableCell>Vendor Code</TableCell>
	  <TableCell>Quantity In Stock</TableCell>
	  <TableCell>Reorder Level</TableCell>
	  <TableCell>Reorder Quantity</TableCell>
	  <TableCell>Location</TableCell>
	  <TableCell>Active</TableCell>
	   <TableCell>Barcode</TableCell>
	    <TableCell>Weight</TableCell>
		 <TableCell>Unit of Weight</TableCell>    
      {Array.from({ length: maxProducts }).map((_, i) => (
        <React.Fragment key={i}>
          <TableCell>Selling Price Name</TableCell>         
          <TableCell>Selling Price  Value</TableCell>
          <TableCell>Selling Price 1 Includes Tax</TableCell>
        </React.Fragment>
      ))}
    </TableRow>
  </TableHead>

  <TableBody>
    {this.state.ExportData.map((product, index) => {
      const productprice = product.productprice || [];
      return (
        <TableRow key={index}>
          <TableCell>{product.pr_code}</TableCell>
          <TableCell>{product.pr_description}</TableCell>
          <TableCell>{product.ca_name}</TableCell>
		  <TableCell>{product.le_code}</TableCell>
<TableCell>{product.tx_name}</TableCell>
<TableCell>{product.pr_expensedescription}</TableCell>
<TableCell>{product.pr_costprice}</TableCell>
<TableCell>{product.explecode}</TableCell>
<TableCell>{product.pr_notes}</TableCell>
<TableCell></TableCell>
<TableCell>{product.pr_quantityinhand}</TableCell>
<TableCell>{product.pr_reorderlevel}</TableCell>
<TableCell>{product.pr_reorderquantity}</TableCell>
<TableCell>{product.pr_location}</TableCell>
<TableCell>{product.pr_isactive}</TableCell>
<TableCell>{product.pr_barcode}</TableCell>
<TableCell>{product.pr_weight}</TableCell>
<TableCell>{product.prunit}</TableCell>

          {Array.from({ length: maxProducts }).map((_, i) => {
            const item = productprice[i];
            const fields = ['gm_name', 'pp_price', 'includetax'];
            return fields.map(field => (
              <TableCell key={i + '-' + field} style={{ border: '1px solid #e0e0e0' }}>
                {item ? item[field] : ''}
              </TableCell>
            ));
          })}
        </TableRow>
      );
    })}
  </TableBody>
</Table>
	 </React.Fragment> 
	 )
	}
}








